import public_profile_influencer from "./ProfileInfluencer";

export default public_profile_influencer;
